export default __webpack_public_path__ + "gumtree-logo.5406eb0146147ff4929646c635d86e45.png";